module.exports = __webpack_public_path__ + "static/street-tokyo-af168a81f93e15c32d796c44f81c034b.png";